import moment from '@/plugins/vue-moment.js';

const HOURS = 3600;

export default {
    namespaced: true,

    state: {
        timestamp: null,
    },

    actions: {
        setTimestamp({ commit }) {
            commit('SET_APP_TIMESTAMP', moment());
        },

        isStale({ state }) {
            const initialTimestamp = state.timestamp;
            const difference = moment().diff(initialTimestamp, 'seconds');

            return difference >= 6 * HOURS;
        },
    },

    mutations: {
        SET_APP_TIMESTAMP(state, date) {
            state.timestamp = date;
        },
    },
};
